import React, { useState, useEffect } from 'react';
import './SiteHeader.css';

const SiteHeader = ({ active = '', onSmartData = false }) => {
  const [navOpen, setNavOpen] = useState(false);
  const [solOpen, setSolOpen] = useState(false);
  const [bannerVisible, setBannerVisible] = useState(true);

  useEffect(() => {
    const update = () => {
      const now = new Date();
      const d = new Date(now.toLocaleString('en-US', { timeZone: 'Europe/Dublin' }));
      const day = d.getDay();
      const m = d.getHours() * 60 + d.getMinutes();
      const open = (day >= 1 && day <= 4 && m >= 540 && m < 1080) || (day === 5 && m >= 540 && m < 720);
      const ind = document.querySelector('.sh-status-dot');
      const txt = document.querySelector('.sh-hours-text');
      const box = document.querySelector('.sh-hours');
      if (ind && txt && box) {
        ind.className = 'sh-status-dot ' + (open ? 'open' : 'closed');
        txt.textContent = open ? 'OPEN' : 'CLOSED';
        box.classList.toggle('is-open', open);
      }
    };
    update();
    const i = setInterval(update, 60000);
    return () => clearInterval(i);
  }, []);

  const cls = (name) => 'sh-navlink' + (active === name ? ' active' : '');

  return React.createElement(React.Fragment, null,
    React.createElement('header', { className: 'site-header' },
      React.createElement('div', { className: 'sh-container' },
        React.createElement('a', { href: '/', className: 'sh-logo' },
          React.createElement('span', { className: 'sh-logo-text' }, 'DBOS.world')
        ),
        React.createElement('a', { href: 'https://portal.dbos.world', className: 'sh-login', target: '_blank', rel: 'noopener noreferrer' },
          React.createElement('img', { src: '/assets/img/dbos-3d-logo.png', className: 'sh-login-d', alt: '' }),
          'Login'
        ),
        React.createElement('div', { className: 'sh-strip' },
          React.createElement('button', { className: 'sh-burger', onClick: () => setNavOpen(!navOpen), 'aria-label': 'Menu' },
            React.createElement('span'), React.createElement('span'), React.createElement('span')
          ),
          React.createElement('a', { href: 'https://wa.me/353892208150', className: 'sh-contact', target: '_blank', rel: 'noopener noreferrer' },
            React.createElement('span', { className: 'sh-icon' }, '\uD83D\uDCAC'),
            React.createElement('span', { className: 'sh-ctext' }, ' WhatsApp')
          ),
          React.createElement('a', { href: 'tel:+353894148105', className: 'sh-contact' },
            React.createElement('span', { className: 'sh-icon' }, '\uD83D\uDCDE'),
            React.createElement('span', { className: 'sh-ctext' }, ' Call Us')
          ),
          React.createElement('div', { className: 'sh-hours' },
            React.createElement('span', { className: 'sh-status-dot' }),
            React.createElement('span', { className: 'sh-hours-text' })
          )
        ),
        React.createElement('nav', { className: 'sh-nav' + (navOpen ? ' open' : '') },
          React.createElement('div', { className: 'sh-dropdown' + (solOpen ? ' open' : '') },
            React.createElement('span', { className: cls('solutions'), onClick: () => setSolOpen(!solOpen) }, 'Solutions \u25BC'),
            React.createElement('div', { className: 'sh-dropdown-menu' },
              React.createElement('a', { href: '/smartdata' }, 'SmartData'),
              React.createElement('a', { href: '/smartshop' }, 'SmartShop'),
              React.createElement('a', { href: '/smartweb' }, 'SmartWeb'),
              React.createElement('a', { href: '/smartmail' }, 'SmartMail'),
              React.createElement('a', { href: '/smartfinance' }, 'SmartFinance'),
              React.createElement('a', { href: '/smarttraffic' }, 'SmartTraffic')
            )
          ),
          React.createElement('a', { href: '/technology', className: cls('technology') }, 'Technology'),
          React.createElement('a', { href: '/news', className: cls('news') }, 'News & Events'),
          React.createElement('a', { href: '/our-story', className: cls('our-story') }, 'Our Story')
        )
      )
    ),
    bannerVisible && React.createElement('div', { className: 'sh-banner' },
      React.createElement('div', { className: 'sh-banner-inner' },
        React.createElement('img', { src: '/assets/img/dbos-3d-logo.png', className: 'sh-banner-d', alt: '' }),
        React.createElement('span', { className: 'sh-banner-text' },
          React.createElement('strong', null, 'SmartData is live'),
          ' - start your free 7-day trial today. No credit card required.',
          !onSmartData && React.createElement('a', { href: '/smartdata', className: 'sh-banner-details' }, ' See Details')
        ),
        React.createElement('a', { href: 'https://login.dbos.world/register', className: 'sh-banner-cta', target: '_blank', rel: 'noopener noreferrer' }, 'Start Free Trial \u2192'),
        React.createElement('button', { className: 'sh-banner-x', onClick: () => setBannerVisible(false), 'aria-label': 'Close' }, '\u2715')
      )
    )
  );
};

export default SiteHeader;
